import { render, staticRenderFns } from "./CustleavingDetail.vue?vue&type=template&id=6438dd41"
import script from "./CustleavingDetail.vue?vue&type=script&lang=js"
export * from "./CustleavingDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports